import { ErrorContentModel } from './../../../core/models/ErrorContentModel.interface';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FunctionType } from '../../types/function.type';
import { FunctionHandlerService } from '../../../core/services/function-handler/function-handler.service';
import { BciWkModalService, BCI_WK_MODAL_DATA } from '@bci/webkitbci';
import { content } from 'src/app/core/utils/error-content';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GenericModalComponent {
  data!: ErrorContentModel;

  constructor(
    private fnHandlerService: FunctionHandlerService,
    private modal: BciWkModalService,
    @Inject(BCI_WK_MODAL_DATA) public code: string
  ) {
    this.data = content[code];
  }

  onClickBtn(action: [FunctionType, string] | null) {
    this.modal.close();
    if(action)
    this.fnHandlerService.handle(action[0], action[1]);
  }
}
